import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuotationItem } from '../../../models/quotation_item.model'
import { MasterCommonServices } from '../../../master.common.service'

@Component({
  selector: 'app-quotation-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quotationDetails.component.html',
  styleUrl: './quotationDetails.component.css',
})
export class QuotationDetailsComponent {
  @Input() quotationItems: QuotationItem[] = []
  @Input() quotationTerms: any
  @Input() quotationFields: any

  constructor(public masterCommonServices: MasterCommonServices) {}

  isLoading: boolean = false
  submitted: boolean = false
  isToastrShown: boolean = false
}
